(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('regional-purchase-buttons')) {
    customElements.define('regional-purchase-buttons', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { capture: true, signal: this.abortController.signal };
        this.addEventListener('submit', (event) => this.checkout(event), options);
        this.addEventListener('click', (event) => this.prepareWhatsApp(event), options);
        this.observer = new MutationObserver(() => this.syncButton());
        this.observer.observe(this, { childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['class', 'style', 'disabled'] });
        this.syncButton();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }
      syncButton() {
        const original = this.querySelector('button[name="add"]');
        const whatsapp = this.querySelector('[data-regional-whatsapp]');
        if (!original) return;
        if (!original.disabled) {
          const walker = document.createTreeWalker(original, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (node.textContent.trim() === this.dataset.originalLabel) {
              node.textContent = 'Comprar ahora Medellín';
            }
          }
        }
        if (!whatsapp) return;
        // Comparte clases y variables visuales, sin heredar el estado disabled.
        const classes = [...original.classList].filter((name) =>
          !['disabled', 'loading', 'is-loading', 'is-disabled', 'hidden'].includes(name)
        ).concat('regional-whatsapp').join(' ');
        if (whatsapp.className !== classes) whatsapp.className = classes;
        const style = original.getAttribute('style') || '';
        if ((whatsapp.getAttribute('style') || '') !== style) whatsapp.setAttribute('style', style);
      }
      prepareWhatsApp(event) {
        const link = event.target.closest('[data-regional-whatsapp]');
        if (!link || !this.contains(link)) return;
        const form = link.closest('form');
        if (!form) return;
        const data = new FormData(form);
        const productUrl = new URL(this.dataset.productUrl, window.location.origin);
        if (data.get('id')) productUrl.searchParams.set('variant', data.get('id'));
        const message = [this.dataset.whatsappMessage, '',
          'Producto: ' + this.dataset.productTitle,
          'Cantidad: ' + (data.get('quantity') || '1'), productUrl.href].join('\n');
        link.href = 'https://wa.me/' + this.dataset.whatsappNumber.replace(/\D/g, '') +
          '?text=' + encodeURIComponent(message);
      }
      async checkout(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.loading || !form.reportValidity()) return;
        const button = form.querySelector('button[name="add"]');
        if (!button || button.disabled) return;
        const errorBox = this.querySelector('[data-regional-error]');
        const statusBox = this.querySelector('[data-regional-status]');
        const data = new FormData(form);
        if (!data.get('id')) {
          errorBox.textContent = 'Selecciona una variante disponible.';
          errorBox.hidden = false;
          return;
        }
        // Los campos del formulario conservan cantidad, propiedades y selling_plan.
        data.delete('return_to');
        this.loading = true;
        errorBox.hidden = true;
        statusBox.textContent = 'Preparando tu compra…';
        statusBox.hidden = false;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json' }, body: data
          });
          const result = await response.json();
          if (!response.ok || Number(result.status) >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description :
              'No fue posible agregar el producto. Revisa la disponibilidad y la cantidad.');
          }
          added = true;
          statusBox.textContent = 'Abriendo el checkout…';
          window.location.assign(root + 'checkout');
        } catch (error) {
          statusBox.hidden = true;
          errorBox.textContent = error.message || 'No fue posible continuar. Revisa tu conexión.';
          errorBox.hidden = false;
        } finally {
          if (!added) {
            this.loading = false;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contador-apertura"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('apertura-countdown')) {
    customElements.define('apertura-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.endAt = Date.parse(this.dataset.endAt);
        this.clock = this.querySelector('[data-clock]');
        this.heading = this.querySelector('[data-heading]');
        this.dateLabel = this.querySelector('[data-date]');
        this.complete = this.querySelector('[data-complete]');
        this.error = this.querySelector('[data-error]');
        this.summary = this.querySelector('[data-summary]');
        this.digits = ['days', 'hours', 'minutes', 'seconds'].map(
          (unit) => this.querySelector('[data-' + unit + ']')
        );

        const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(this.dataset.endAt || '');
        if (!hasTimezone || !Number.isFinite(this.endAt)) {
          this.clock.hidden = true;
          if (this.heading) this.heading.hidden = true;
          if (this.dateLabel) this.dateLabel.hidden = true;
          this.complete.hidden = true;
          this.error.hidden = false;
          if (window.Shopify && window.Shopify.designMode) {
            this.error.textContent = 'Revisa la fecha. Usa el formato 2026-10-09T17:00:00-05:00.';
          }
          return;
        }

        this.error.hidden = true;
        this.onVisibility = () => {
          if (!document.hidden) this.update();
        };

        if (this.update()) {
          this.timer = window.setInterval(() => this.update(), 1000);
          document.addEventListener('visibilitychange', this.onVisibility);
        }
      }

      update() {
        const remaining = this.endAt - Date.now();
        if (remaining <= 0) {
          this.clock.hidden = true;
          if (this.heading) this.heading.hidden = true;
          if (this.dateLabel) this.dateLabel.hidden = true;
          this.complete.hidden = false;
          this.stop();
          return false;
        }

        const seconds = Math.ceil(remaining / 1000);
        const values = [
          Math.floor(seconds / 86400),
          Math.floor((seconds % 86400) / 3600),
          Math.floor((seconds % 3600) / 60),
          seconds % 60
        ];

        values.forEach((value, index) => {
          const text = String(value).padStart(2, '0');
          if (this.digits[index].textContent !== text) {
            this.digits[index].textContent = text;
          }
        });

        this.summary.textContent = values[0] + ' días, ' + values[1] +
          ' horas, ' + values[2] + ' minutos y ' + values[3] + ' segundos para la apertura.';
        this.clock.hidden = false;
        this.complete.hidden = true;
        if (this.heading) this.heading.hidden = false;
        if (this.dateLabel) this.dateLabel.hidden = false;
        return true;
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
        if (this.onVisibility) {
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
